import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { WebviewCommunicationService } from '@shared/core';
import { LocalizationPipe } from '@shared/modules/localization';
import { APP_STORE_LINKS } from '../../../../shared/constants/app-store-links.const';

@Component({
  selector: 'pkp-d-app-download-banner',
  standalone: true,
  templateUrl: './app-download-banner.component.html',
  styleUrl: './app-download-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [LocalizationPipe],
})
export class AppDownloadBannerComponent {
  private readonly webviewService = inject(WebviewCommunicationService);
  private readonly isWebviewInitialized = toSignal(
    this.webviewService.isNsWebViewInterfaceInitialized$,
    { initialValue: false },
  );

  readonly stores = APP_STORE_LINKS;
  readonly isVisible = computed(
    () => !this.webviewService.isInNativeWebView && !this.isWebviewInitialized(),
  );
}
